import { URL_API_IMAGES } from "../constants/API"

interface PropsMediaFilter {
  path?:string
}
export const mediaFilter = ({ path }: PropsMediaFilter) => {
  return `${URL_API_IMAGES}${path}`
  //return `/back/${path}`
}